import { useEffect, useState } from "react";

import { layerInfosWithDeps } from "../../../../../resources/layers";

export const useLayerDeps = (layerName?: string) => {
  const [loading, setLoading] = useState<boolean>(true);

  const { data: layerInfo, refetch } = layerInfosWithDeps.use({
    input: [layerName],
    waitInput: true,
    immediate: false,
  });

  useEffect(() => {
    refetch().then(() => setLoading(false));
  }, [refetch]);

  return {
    layers: layerInfo?.layers,
    tables: layerInfo?.deps.tables,
    loading,
  };
};
